import React from 'react'

import { ZariContext } from '_zari/context'

import { Button, Table, Modal, Divider, Row, Col } from '_zari/core'

import { EstadosPartidasConstant } from 'constants/index'

import { IdGen } from 'utils'

import * as PartidasService from 'services/partida.service'

import * as Sections from './sections'

const PartidaCrudModal = ({ handleClose, show, idSocio }) => {
  const __zariContext = React.useContext(ZariContext)

  const [mostrarSection, setMostrarSection] = React.useState(false)
  const [keySection, setKeySection] = React.useState(IdGen.newId())

  const tableRef = React.useRef()
  const sectionDataRef = React.useRef({})

  const clickCambiarEstado = React.useCallback(
    ({ _id, estado }) => {
      PartidasService.actualizarEstadoxId(_id, {
        estado
      })
        .then(() => {
          tableRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const clickEditar = React.useCallback(
    ({ _id }) => {
      PartidasService.getxIdAsEdicion(_id)
        .then(({ data }) => {
          sectionDataRef.current = data
          setMostrarSection(true)
          setKeySection(IdGen.newId())
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const clickEliminar = React.useCallback(
    ({ _id }) => {
      PartidasService.eliminarxId(_id)
        .then(() => {
          tableRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const clickNuevaPartida = React.useCallback(() => {
    sectionDataRef.current = {}
    setMostrarSection(true)
    setKeySection(IdGen.newId())
  }, [])

  const cancelOperation = React.useCallback(() => {
    setMostrarSection(false)
    sectionDataRef.current = {}
    setKeySection(IdGen.newId())
  }, [])

  const reloadTable = React.useCallback(() => {
    tableRef.current.reload()
    setMostrarSection(false)
    sectionDataRef.current = {}
    setKeySection(IdGen.newId())
  }, [])

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>PARTIDAS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!mostrarSection && (
          <Row>
            <Col md={12} className='text-right'>
              <Button onClick={clickNuevaPartida}>Nueva Partida</Button>
            </Col>
          </Row>
        )}
        {mostrarSection && (
          <Sections.CrearEditarSection
            key={keySection}
            cancelOperation={cancelOperation}
            defaultValue={sectionDataRef.current}
            reloadTable={reloadTable}
            idSocio={idSocio}
          />
        )}
        <Divider />
        <Table.ServerSide
          useNest={true}
          ref={tableRef}
          url='/partidas'
          rowsPerPage={4}
          headRows={[{ label: 'TITULO' }, { label: 'ESTADO' }, { label: '' }]}
          baseParams={{
            idSocio: idSocio
          }}
          rowTemplate={row => (
            <Table.Row>
              <Table.Cell>{row.titulo || '--'}</Table.Cell>
              <Table.Cell>
                {row.estado ? EstadosPartidasConstant.__dictionary[row.estado].nombre : '--'}
              </Table.Cell>
              <Table.Cell>
                <Table.Dropdown>
                  {({ handleClose }) => [
                    <Table.Dropdown.Item
                      key='cambiar-estado'
                      handleClose={handleClose}
                      onClick={e =>
                        clickCambiarEstado({
                          _id: row._id,
                          estado:
                            row.estado === EstadosPartidasConstant.HABILITADO
                              ? EstadosPartidasConstant.INHABILITADO
                              : EstadosPartidasConstant.HABILITADO
                        })
                      }
                    >
                      {row.estado === EstadosPartidasConstant.HABILITADO
                        ? 'Inhabilitar'
                        : 'Habilitar'}
                    </Table.Dropdown.Item>,
                    <Table.Dropdown.Item
                      key='editar'
                      handleClose={handleClose}
                      onClick={e => clickEditar({ _id: row._id })}
                    >
                      Editar
                    </Table.Dropdown.Item>,
                    <Table.Dropdown.Item
                      key='eliminar'
                      handleClose={handleClose}
                      onClick={e => clickEliminar({ _id: row._id })}
                    >
                      Eliminar
                    </Table.Dropdown.Item>
                  ]}
                </Table.Dropdown>
              </Table.Cell>
            </Table.Row>
          )}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(PartidaCrudModal)
